import React from 'react'

function AlertBanner() {
  return (
<>
  <p>
    Explore a curated selection of projects that demonstrate my expertise in full-stack development,
    AI-driven solutions, SaaS products, and scalable system architecture. Each project highlights
    thoughtful engineering, practical problem solving, and production-ready implementations.
  </p>
  <p>
  Explore my blog on <a
      href="https://medium.com/@theBwoyPrgrmmr"
      className="gitlink"
      target="_blank"
      rel="noopener noreferrer"
    >
      Medium
    </a> to read articles on full-stack development, AI-driven products, SaaS architecture, and practical insights from my experience as a CTO and tech founder.
</p>

</>

  )
}

export default AlertBanner